import { render, staticRenderFns } from "./DefaultElectrical.vue?vue&type=template&id=35171432&"
import script from "./DefaultElectrical.vue?vue&type=script&lang=js&"
export * from "./DefaultElectrical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports